import LoadingComponent from 'components/common/loading';
import Text from 'components/elements/text';
import useGetCruiseRoom from 'hooks/use-get-cruise-room';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import CruiseGuestDetailTable from './item-table';
import CruiseGuestDetailGroupedTable from './item-table-grouped';
import { CruiseSaleFormType } from '../../form-type';

interface Props {
  parentIndex: number;
}

export default function GroupDetailTable({ parentIndex }: Props) {
  const { control } = useFormContext<CruiseSaleFormType>();
  const { isGroupedPrice, cruiseSaleGuests, cruiseId } = useWatch({
    control,
    name: `cruiseSales.${parentIndex}`,
  });
  const { isFetching, options } = useGetCruiseRoom({ cruiseId });

  if (!cruiseId || !cruiseSaleGuests.length) {
    return <></>;
  }

  if (!cruiseSaleGuests.length || isFetching) {
    return <LoadingComponent style={{ height: 100, width: '100%' }} />;
  }

  if (isGroupedPrice) {
    return (
      <CruiseGuestDetailGroupedTable
        cruiseRoomList={options}
        parentIndex={parentIndex}
      />
    );
  }

  return (
    <>
      {cruiseSaleGuests
        .filter((curr) => !!curr.guestId)
        .map((field, idx) => (
          <React.Fragment key={field.customId}>
            <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
            <SeparatorVertical $margin={16} />
            <CruiseGuestDetailTable
              parentIndex={parentIndex}
              guest={field}
              cruiseRoomList={options}
            />
            <SeparatorVertical $margin={24} />
          </React.Fragment>
        ))}
    </>
  );
}
